module.exports = __webpack_public_path__ + "fonts/iconfont.8563e094.woff";